import { CANADIAN_JURISDICTION_CODES } from '@/consts/enums'
import enumsHelper from '@/helpers/enums'
import i18n from '@/helpers/i18n'

const defaultJurisdictionCode = 'QC'
const JURISDICTION_OTHER = 'OTHER'
const MAX_OTHER_LENGTH = 100

const getJurisdictionTranslation = (code) => enumsHelper.formatJurisdiction(code)

const getCanadianJurisdictions = () => {
  return CANADIAN_JURISDICTION_CODES.map((code) => ({
    value: code,
    text: getJurisdictionTranslation(code)
  }))
}

const getAllJurisdictions = () => {
  return [
    ...getCanadianJurisdictions(),
    {
      value: JURISDICTION_OTHER,
      text: i18n.t('jurisdiction-code-OTHER')
    }
  ]
}

const getJurisdictionDisplay = (code, other) => {
  if (code === JURISDICTION_OTHER) {
    return other ? other.trim() : ''
  }
  return getJurisdictionTranslation(code)
}

const isOtherJurisdiction = (code) => code === JURISDICTION_OTHER

const normalizeJurisdictionOther = (code, other) => {
  if (!isOtherJurisdiction(code)) {
    return null
  }
  return (other == null ? '' : other).trim()
}

const validateJurisdictionOther = (code, other, emptyMessage, maxLengthMessage) => {
  if (!isOtherJurisdiction(code)) {
    return true
  }
  const normalized = normalizeJurisdictionOther(code, other)
  if (!normalized) {
    return emptyMessage
  }
  if (normalized.length > MAX_OTHER_LENGTH) {
    return maxLengthMessage
  }
  return true
}

export default {
  defaultJurisdictionCode,
  JURISDICTION_OTHER,
  MAX_OTHER_LENGTH,
  getCanadianJurisdictions,
  getAllJurisdictions,
  getJurisdictionTranslation,
  getJurisdictionDisplay,
  isOtherJurisdiction,
  normalizeJurisdictionOther,
  validateJurisdictionOther
}
